/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { InstructionApi } from '../api/instruction.api';
import { switchMap, map } from 'rxjs/operators';
import { InstructionData, Instruction } from '../../../interfaces/masters/instruction';

@Injectable()
export class InstructionService extends InstructionData {

  constructor(private api: InstructionApi) {
    super();
  }
 

  list(url: string): Observable<Instruction[]> {
    return this.api.list(url);
  }

  getById(url:string): Observable<Instruction>{
      return this.api.getById(url);
  }

  create(url: string, data:Instruction): Observable<Instruction[]> {
    return this.api.add(url,data);
  }

  update(url: string, data:Instruction): Observable<Instruction> {
    return this.api.update(url,data);
  }

  

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
